export default __webpack_public_path__ + "static/media/bg-ajuda.79d3d379.webp";